<div>
  <button id="btnM" hidden="true" (click)="clickBtnMaluco()">Cancelar</button>
</div>

<div class="theme-{{theme}}" >
  <app-landing-menu [ngClass]="{'d-none': !isLandingPage}"> </app-landing-menu>
  <app-navigation class="hide-print"  [ngClass]="{'d-none': hideNavigation || !user}"></app-navigation>
  <div [ngClass]="{'p-0': hideNavigation || !user}" class="page-container bg-light">
      <router-outlet></router-outlet>
  </div>

  <a
    [href]="supportWhatsappUrl"
    target="_blank"
    rel="noopener noreferrer"
    class="support-float hide-print"
    aria-label="Fale com o suporte no WhatsApp"
  >
    <i class="fab fa-whatsapp" aria-hidden="true"></i>
    <span>Suporte</span>
  </a>
</div>

<app-landing-footer [ngClass]="{'d-none': !isLandingPage}" ></app-landing-footer>
